module.exports = __webpack_public_path__ + "img/h_icon_artists.46a7a95f.png";